<script setup>
import {onMounted, ref} from "vue";
import Button from "@/Components/Button.vue";
import {Table, TD, TH, THead, TR} from "@/Components/Table";
import {datetimeFormat} from "@/plugins/utils/time-utils";
import {loadPassingScoreInfo} from "@/Pages/Education/ReceptionCompany/CompetitionLists/competitionListUtils";
import Loader from "@/Components/Loader.vue";
import TBody from "@/Components/Table/TBody.vue";

const loading = ref(true);
const passingScoreInfo = ref(null);

async function updateData() {
    loading.value = true;
    loadPassingScoreInfo()
        .then(value => { passingScoreInfo.value = value; })
        .catch(_ => { passingScoreInfo.value = null; })
        .finally(() => { loading.value = false; });
}

onMounted(() => { updateData(); });
</script>

<template>
<div class="min-w-full p-5">
    <div class="space-x-1 flex flex-row">
        <Button class="b-primary" @click="updateData">
            <i class="fas fa-rotate mr-2"/> Обновить список
        </Button>
    </div>

    <div v-if="loading" class="mt-4 flex flex-col items-center">
        <Loader/>
    </div>

    <div v-else class="mt-4">
        <Table class="border">
            <thead class="border">
                <tr class="border bg-gray-100">
                    <TH class="border !font-bold text-left" colspan="4">
                        <span class="text-[0.7rem] font-light text-gray-600">
                            <i class="fas fa-clock mr-1"/> Данные актуальны на: {{ passingScoreInfo?.meta?.last_update ? datetimeFormat(passingScoreInfo?.meta?.last_update) : 'Нет данных' }}
                        </span>
                    </TH>
                </tr>

                <tr class="border bg-gray-100">
                    <TH class="border !font-bold text-left">
                        Направление
                        <br/>
                        <span class="!text-sm text-gray-500">(Профиль)</span>
                    </TH>
                    <TH class="border !font-bold text-center">Последний проходящий</TH>
                    <TH class="border !font-bold text-center">Проходной балл</TH>
                    <TH class="border !font-bold text-center">Cвободных мест / Всего мест</TH>
                </tr>
            </thead>

            <TBody>
                <TR v-if="!passingScoreInfo?.data" class="border">
                    <TD class="border text-center" colspan="4">Нет данных</TD>
                </TR>

                <template v-else>
                    <TR v-for="(item, guid) in passingScoreInfo?.data" :key="guid">
                        <TD class="border text-left">
                            {{ item.concurs_group.speciality.full_name }}
                            <template v-if="!!item.concurs_group.specializations">
                                <br/>
                                <span class="text-xs font-bold text-gray-500">({{ item.concurs_group.specializations.map((item) => item.name).join(', ') }})</span>
                            </template>
                        </TD>
                        <TD class="border text-center">
                            <template v-if="!item.last_passed">-</template>
                            <template v-else>
                                {{ item.last_passed?.code ?? 'Код не установлен' }}
                            </template>
                        </TD>
                        <TD class="border text-center">
                            <template v-if="!item.last_passed">-</template>
                            <template v-else>
                                <template v-if="item.last_passed.is_bvi">БВИ</template>
                                <template v-else>{{ item.last_passed.points.total }}</template>
                            </template>
                        </TD>
                        <TD class="border text-center">{{ item.places.free }} / {{ item.places.total }}</TD>
                    </TR>
                </template>
            </TBody>
        </Table>
    </div>
</div>
</template>

<style scoped>

</style>
